import { css, Theme } from "@emotion/react"

export const activeRowItem = (theme: Theme) => css`
    background-color: ${theme.palette.Midnight[10]};

    .MuiTypography-root {
        color: ${theme.palette.Midnight};
    }
`

export const rowItemContent = (theme: Theme) => css`
    display: flex;
    gap: ${theme.spacing(1)};
    align-items: center;
`
